import {
  Modal,
  registerBottomSheets,
  registerModals,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';
import { selectCategories } from '../state';
import { store } from '@bonanza-social/toolkit/store';
import { createSearchParams } from 'react-router';
import { ComponentProps, JSXElementConstructor } from 'react';
import { generateUrlName } from '../utils/games';
import Search from '../components/Search/Search';
import { PlayWithCoinsInfo } from '../bottomsheets';
import { LowBalanceBottomSheet } from '../bottomsheets/LowBalance';

registerNavigationHandlers<
  AppNavigatorParamsList,
  | 'GameplayScreen'
  | 'GameInfoScreen'
  | 'AllGamesScreen'
  | 'SearchScreen'
  | 'ProviderGamesScreen'
  | 'CategoryDetailsScreen'
  | 'PlayWithCoinsScreen'
>({
  GameplayScreen(navigate, params) {
    if (!params) {
      return;
    }

    const { id, currencyCode = '' } = params;

    navigate(`/games/launch/${id}${currencyCode && `/${currencyCode}`}`, {
      state: { eligible: true },
      replace: window.location.pathname.startsWith('/games/launch/'),
    });
  },
  GameInfoScreen(navigate, params) {
    if (!params) {
      return;
    }

    const { name } = params;

    navigate(`/games/${generateUrlName(name)}`);
  },
  AllGamesScreen(navigate) {
    navigate('/all');
  },
  SearchScreen() {
    Modal.open({
      namespace: 'games',
      type: 'Search',
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        backgroundColor: 'screenBackground',
      },
    });
  },
  ProviderGamesScreen(navigate, params) {
    navigate({
      pathname: '/games/top-slot-providers',
      search: params?.subProviderName
        ? createSearchParams({
            subProviderName: params.subProviderName,
          }).toString()
        : undefined,
    });
  },
  CategoryDetailsScreen(navigate, params) {
    if (!params) {
      return;
    }

    const categories = selectCategories(store.getState());
    const { id } = params;
    const categorySlug = categories[id]?.slug;

    navigate(categorySlug ? `/${categorySlug}` : '/games');
  },
  PlayWithCoinsScreen(navigate) {
    navigate('/play-with-coins');
  },
});

const modals = {
  Search,
};

registerModals('games', modals);

const bottomSheets = {
  PlayWithCoinsInfo,
  LowBalance: LowBalanceBottomSheet,
};

registerBottomSheets('games', bottomSheets);

declare global {
  interface RegisteredModals {
    games: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
